export enum DialogTheme {
    Small = 'small',
    Medium = 'medium',
    Big = 'big',
}
